<script setup lang="ts">
import type { ProductDocument } from "@/schemas/product-document";

defineProps<{ product: ProductDocument }>();
const formatList = (value: unknown) => (value as string[]).join(", ");
const properties = [
  { key: "categories" as keyof ProductDocument, label: "Catégorie", format: formatList },
  { key: "pa_langue" as keyof ProductDocument, label: "Langue", format: formatList },
  { key: "pa_mecanique" as keyof ProductDocument, label: "Mécanique de jeu", format: formatList },
  { key: "pa_niveau" as keyof ProductDocument, label: "Niveau", format: formatList },
  { key: "pa_public_cible" as keyof ProductDocument, label: "Public cible", format: formatList },
  { key: "pa_type_de_jeu" as keyof ProductDocument, label: "Type de jeu", format: formatList },
  { key: "pa_collection" as keyof ProductDocument, label: "Collection", format: formatList },
  { key: "pa_type_de_bricolage" as keyof ProductDocument, label: "Type de bricolage", format: formatList },
  { key: "pa_type_de_casse_tete" as keyof ProductDocument, label: "Type de casse-tête", format: formatList },
  { key: "pa_marque" as keyof ProductDocument, label: "Marque", format: formatList },
];
</script>

<template>
  <div class="flex flex-col gap-2">
    <div class="text-xl font-semibold text-primary">
      Spécifications
    </div>
    <hr class="text-light">
    <dl class="list-specifications">
      <template v-for="property in properties" :key="property.key">
        <div v-if="product[property.key]">
          <dt>{{ property.label }}:</dt>
          <dd>{{ property.format(product[property.key]) }}</dd>
        </div>
      </template>
      <div v-if="product.product_age_min">
        <dt>Âge recommandé:</dt>
        <dd v-if="!product.product_age_max || (product.product_age_min === product.product_age_max)">
          {{ product.product_age_min }} ans
        </dd>
        <dd v-else-if="product.product_age_max">
          {{ product.product_age_min }} à {{ product.product_age_max }} ans
        </dd>
      </div>
      <div v-if="product.game_nb_players_min && product.game_nb_players_max">
        <dt>Nombre de joueurs:</dt>
        <dd>{{ product.game_nb_players_min }} à {{ product.game_nb_players_max }}</dd>
      </div>
      <div v-if="product.game_duration_min && product.game_duration_max">
        <dt>Durée:</dt>
        <dd>{{ product.game_duration_min }} à {{ product.game_duration_max }} minutes</dd>
      </div>
      <div v-if="product.puzzle_nb_pieces">
        <dt>Nombre de pièces:</dt>
        <dd>{{ product.puzzle_nb_pieces }}</dd>
      </div>
    </dl>
  </div>
</template>
